import {observer} from "mobx-react-lite";
import React from "react";
import {ContractInsightsExpandableTable} from "../table/ContractExpandableTable";
import {CurrencyComponent} from "../../../components/currency-component/CurrencyComponent";
import {environment} from "../../../env";
import type {KpiBoxedValue} from "../../../components/kpi-boxed-values/KpiBoxedValues.tsx";
import {KpiBoxedValues} from "../../../components/kpi-boxed-values/KpiBoxedValues.tsx";

export const ContractInsightsComponent: React.FC = observer(() => {
    const kpiValues = React.useMemo<KpiBoxedValue[]>(() => !environment.isDemo ? [] : [
        {
            title: 'Active contracts',
            subtitle: 134,
        }, {
            title: 'Expired contracts',
            subtitle: 21,
        }, {
            title: 'Total transactional spend annually',
            subtitle: <CurrencyComponent v={88530000} nDigits={3}/>,
        },
    ], []);
    return (
        <div className="contract-insights-component-page">
            {/*Header*/}
            <KpiBoxedValues values={kpiValues}/>

            <ContractInsightsExpandableTable/>
        </div>
    );
});
